const GlobalStockTable = require('okCharts/GlobalStockTable');

module.exports = GlobalStockTable;
